"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const utils_1 = require("../../utils");
const buildChoicesMap = lodash_1.memoize((choiceGroups) => lodash_1.chain(choiceGroups)
    .flatMap(({ items }) => items)
    .keyBy('value')
    .value());
function getPreviewPillProps(choiceGroups, tag) {
    const choices = buildChoicesMap(choiceGroups);
    const choice = choices[tag];
    const label = lodash_1.get(choice, 'label') || utils_1.humanize(tag);
    return {
        api: lodash_1.get(choice, 'selectedApi'),
        label,
        stepNumber: lodash_1.get(choice, 'stepNumber'),
        sample: lodash_1.get(choice, 'sample'),
    };
}
exports.default = getPreviewPillProps;
